import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import HeaderBanner from "@components/V2/Banners/HeaderBanner"

const StoryBlokHeaderBanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.HeaderBanner>) => {
  const highlightedWords = blok.highlightedWords
    ?.split("\n")
    .map((word) => word.trim())
    .filter(Boolean)

  return (
    <HeaderBanner
      title={blok.title}
      hideBorder={blok.hideBorder}
      backgroundColor={blok.backgroundColor}
      borderColor={blok.borderColor}
      highlightedWords={highlightedWords}
      sectionColor={blok.sectionColor}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryBlokHeaderBanner
